import { useEffect, useState } from "react";
import UserProfile from "../Context/UserProfile";
import ContractList from "./ContractList";


const ContractListPage = ({ setUserName,setPageTitle }) => {
    useEffect(() => {
        setUserName(UserProfile.getName());
        setPageTitle("All contracts");

    }, []);

    return (<>
        <div className="main-content">
            <ContractList/>
        </div>
    </>);
}
export default ContractListPage;